import { RootState } from "../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.downloadQrcode.loading;
export const getDownloadQrcodeErrorMessage = (state: RootState) =>
  state.downloadQrcode.error;
export const getDownloadQrcodeSuccessResponse = (state: RootState) =>
  state.downloadQrcode.downloadQrResponse;
